// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hgVx7A9f3oZaSl {
  position: relative;
  min-height: 36px;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
  cursor: pointer;
  scroll-margin: var(--ds-space-100, 8px);
}
.udCQxREgNH1W01 {
  display: flow-root;
  position: relative;
  z-index: 10;
  min-height: 24px;
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px) var(--ds-space-050, 4px);
}
.N2Zl5vlIYuLpVv {
  border-bottom-right-radius: var(--ds-border-radius-200, 8px);
  border-bottom-left-radius: var(--ds-border-radius-200, 8px);
  background-color: rgba(255, 255, 255, 0.7);
}
:where(html[data-color-mode='dark']) .N2Zl5vlIYuLpVv {
  background-color: rgba(29, 33, 37, 0.7);
}
.ReeBl7DePsdyvv {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  border-radius: var(--ds-border-radius-100, 3px);
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  width: 100%;
  margin-bottom: var(--ds-space-050, 4px);
  padding: var(--ds-space-0, 0);
  overflow: hidden;
  overflow-wrap: break-word;
  resize: none;
}
.ReeBl7DePsdyvv:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.ReeBl7DePsdyvv:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.ReeBl7DePsdyvv:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.ReeBl7DePsdyvv[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.ReeBl7DePsdyvv.FyhpLhTxfIhNa1 {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.ReeBl7DePsdyvv.FyhpLhTxfIhNa1:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.ReeBl7DePsdyvv.FyhpLhTxfIhNa1:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.ReeBl7DePsdyvv.tzbbBl6CPyh4I7 {
  width: 100%;
}
.ReeBl7DePsdyvv::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.ReeBl7DePsdyvv,
.ReeBl7DePsdyvv:hover,
.ReeBl7DePsdyvv:focus {
  background-color: unset;
  box-shadow: revert;
}
.RYMF7FCviGjoRS {
  margin-top: var(--ds-space-100, 8px);
  margin-bottom: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var cardFront = `hgVx7A9f3oZaSl`;
export var details = `udCQxREgNH1W01`;
export var stickersBackdrop = `N2Zl5vlIYuLpVv`;
export var cardNameEditor = `ReeBl7DePsdyvv`;
var _1 = `FyhpLhTxfIhNa1`;
export { _1 as "input-error" };
export var full = `tzbbBl6CPyh4I7`;
export var saveButton = `RYMF7FCviGjoRS`;
export default ___CSS_LOADER_EXPORT___;
